import React, {useEffect, useState} from "react";
import {injectIntl} from "react-intl";
import Row from "@amzn/meridian/row";
import Column from "@amzn/meridian/column";
import DateRangePicker from "@amzn/meridian/date-range-picker"
import addDays from "date-fns/addDays"
import format from "date-fns/format"
import {getHeadersForNFMS, getNFMSEndpoint} from "../../Utils";
import Box from "@amzn/meridian/box";
import axios from "axios";
import PageHeader from "../util/PageHeader";
import {PAGE_HEADERS} from "../util/RouteConstants";
import Input from "@amzn/meridian/input";
import Button from "@amzn/meridian/button";
import {TAT_TABLE_HEADERS} from "../../Constants";
import {TATDataTable} from "./TATDataTable";
import Select, {SelectOption} from "@amzn/meridian/select";
import '../program-launch-status/ProgramLaunchStatus.css';
import Loader from "@amzn/meridian/loader";
import Icon from "@amzn/meridian/icon";
import cogToken from "@amzn/meridian-tokens/base/icon/cog"
import checkCircleToken from "@amzn/meridian-tokens/base/icon/check-circle"

const TatCalculator = () => {

    const [aaaApplicationName, setAaaApplicationName] = useState();
    const [packageName, setPackageName] = useState();
    const [serviceName, setServiceName] = useState();
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [dateRange, setDateRange] = useState();
    const [region, setRegion] = useState();
    const [scalingFactor, setScalingFactor] = useState();
    const [serviceType, setServiceType] = useState();
    const [accountId, setAccountId] = useState();
    const [tatCalculationsList, setTatCalculationsList] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState({
        aaaApplicationName: false,
        serviceName : false,
        packageName : false,
        startDate: false,
        endDate : false,
        scalingFactor : false,
        region: false,
        serviceType: false,
        accountId: false
    });
    const formatIso = date => format(date, "yyyy-MM-dd")
    const today = formatIso(new Date())
    const sevenDaysAgo = formatIso(addDays(new Date(), -14))

    const dummy = [{
            "aaaApplicationName": "StationPickingService",
            "category": "Transportation",
            "type": "LastMile - Outbound",
            "item": "Autocuts",
            "dataList": [
                {
                    "timeout": 14469,
                    "serviceName": "AssignTopPriorityPicklist",
                    "currentTps": 52,
                    "requiredTps": 78,
                    "link": "https://tiny.amazon.com/buul64q7/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=AssignTopPriorityPicklist&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 15184,
                    "serviceName": "AssignPicklist",
                    "currentTps": 2,
                    "requiredTps": 4,
                    "link": "https://tiny.amazon.com/16fn5rc9h/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=AssignPicklist&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 9853,
                    "serviceName": "AddCartToPicklist",
                    "currentTps": 33,
                    "requiredTps": 50,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=AddCartToPicklist&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 7854,
                    "serviceName": "MoveItemToCart",
                    "currentTps": 293,
                    "requiredTps": 440,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=MoveItemToCart&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 3641,
                    "serviceName": "CloseCart",
                    "currentTps": 31,
                    "requiredTps": 47,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=CloseCart&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 1751,
                    "serviceName": "DetachCart",
                    "currentTps": 24,
                    "requiredTps": 36,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=DetachCart&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 45125,
                    "serviceName": "StageCart",
                    "currentTps": 3,
                    "requiredTps": 5,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=StageCart&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                },
                {
                    "timeout": 2636,
                    "serviceName": "ReportIssueForItem",
                    "currentTps": 1,
                    "requiredTps": 2,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=ReportIssueForItem&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=p99&ValueUnit1=millisecond&Label1=p99.9&UserLabel1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                }]
        },
        {
            "aaaApplicationName": "ChloeService",
            "category": "Optimus",
            "type": "Optimus-WIMS",
            "item": "General",
            "dataList": [
                {
                    "timeout": 1120,
                    "serviceName": "GetUserAccounts",
                    "currentTps": 505,
                    "requiredTps": 760,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=ALL&Client1=ALL&MetricClass1=ChloeService&Instance1=getUserAccounts&Metric1=Latency&Period1=OneMinute&Stat1=p99.9&ValueUnit1=millisecond&Label1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"
                }]
        },
        {
            "aaaApplicationName": "AztecService",
            "category": "IdentityServices",
            "type": "AztecService",
            "item": "AAAAllowlist",
            "dataList": [
                {
                    "timeout": 64,
                    "serviceName": "VerifyAccessTokenForPermissions",
                    "currentTps": 505,
                    "requiredTps": 760,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=ALL&Client1=ALL&MetricClass1=AztecService&Instance1=VerifyAccessTokenForPermissions&Metric1=Latency&Period1=OneMinute&Stat1=p99.9&ValueUnit1=millisecond&Label1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"               }]
        },
        {
            "aaaApplicationName": "COMPMasterDataService",
            "category": "Transportation",
            "type": "Delivery Station",
            "item": "NodeExecution",
            "dataList": [
                {
                    "timeout": 75,
                    "serviceName": "GetStations",
                    "currentTps": 21,
                    "requiredTps": 32,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=ALL&Client1=ALL&MetricClass1=COMPMasterDataService&Instance1=GetStations&Metric1=Latency&Period1=OneMinute&Stat1=p99.9&ValueUnit1=millisecond&Label1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"                },
                {
                    "timeout": 236,
                    "serviceName": "GetAllNodeCapabilityConfigurations",
                    "currentTps": 3,
                    "requiredTps": 5,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=StationPickingService%3Aprod%3ANAAmazon&HostGroup1=ALL&Host1=ALL&ServiceName1=StationPickingService&MethodName1=ALL&Client1=ALL&MetricClass1=COMPMasterDataService&Instance1=GetAllNodeCapabilityConfigurations&Metric1=Latency&Period1=OneMinute&Stat1=p99.9&ValueUnit1=millisecond&Label1=p99.9&HeightInPixels=250&WidthInPixels=600&DecoratePoints=true&StartTime1=-P14D&EndTime1=-PT0H"                }]
        },
        {
            "aaaApplicationName": "NARCService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "GetResourcesV2",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "NodeNinjaService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "GetLabelById",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "NodeOperationManagerService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "FetchOperationsForScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "ContainerManagementService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "CreateContainerByScannableV2",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "OpenContainerByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MoveContainerByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetChildContainersByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "CloseContainerByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetContainerInfoByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetResourceInfoByLabel",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetChildContainersByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetParentContainerByScannable",
                    "currentTps": 20.25,
                    "requiredTps": 30,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetParentChainByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetContainerByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "UpdateSortInstructionsByScannable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "RoutePickingService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "AssignOptimalPicklist",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "AssignPicklist",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MarkPicklistInProgress",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetPicklist",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MarkPicklistAsComplete",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MarkPicklistAssignable",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "UnassignPicklist",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "CreateAssignableStageList",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MarkStageListComplete",
                    "currentTps": 20.25,
                    "requiredTps": 30,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MarkAislesPickComplete",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "PackageSystemService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "BatchGetPackageByScannableId",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "BatchUpdatePackageState",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "GetPackageByScannableId",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "StageExecutionService",
            "category": "",
            "type": "",
            "item": "",
            "dataList": [
                {
                    "timeout": 2000,
                    "serviceName": "AssignContainer",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "MoveContainerFrom",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "CreateContainerTask",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "ReportIssueForContainer",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 2000,
                    "serviceName": "StageContainer",
                    "currentTps": 0,
                    "requiredTps": 0,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        },
        {
            "aaaApplicationName": "NodeStowingService",
            "category": "Transportation",
            "type": "LastMile",
            "item": "ContainerSystem",
            "dataList": [
                {
                    "timeout": 4,
                    "serviceName": "ScrubContainer",
                    "currentTps": 5.67,
                    "requiredTps": 8,
                    "link": "https://tiny.amazon.com/1a63k10zf/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=PROD.NA.IAD&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaServiceJlbRelayC&MethodName1=ALL&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=start&Period1=OneMinute&Stat1=p100&ValueUnit1=millisecond&Label1=start&Color1=NONE&UserLabel1=start&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                },
                {
                    "timeout": 5,
                    "serviceName": "InvokeStow",
                    "currentTps": 20.25,
                    "requiredTps": 30,
                    "link": "https://tiny.amazon.com/1338ffpcr/iGraph",
                    "graphImageLink": "https://monitorportal.amazon.com/mws?Action=GetGraph&Version=2007-07-07&SchemaName1=Service&DataSet1=Prod&Marketplace1=NodeNinjaService%3ANAAmazon%3Aprod&HostGroup1=ALL&Host1=ALL&ServiceName1=NodeNinjaService&MethodName1=GetShipmentsByScannableIds&Client1=ALL&MetricClass1=NONE&Instance1=NONE&Metric1=Time&Period1=OneMinute&Stat1=n&ValueUnit1=millisecond&Label1=Time&Color1=NONE&UserLabel1=Time&HeightInPixels=250&WidthInPixels=475&StartTime1=-P3D&EndTime1=-PT0M&actionSource=dashboard"
                }]
        }
    ]


    function GetLaunchDataTable() {
        if(dummy!== undefined && dummy!== null) {
            return (<Box>
                <TATDataTable
                    headers={TAT_TABLE_HEADERS}
                    dependencyMap={tatCalculationsList}
                    serviceName={serviceName}
                    region={region}
                />
            </Box>);
        }
    }


    useEffect(() => {
        if(dateRange!== undefined && dateRange !== null) {
            let dateRangeFromObject = dateRange.toString();
            console.log("dateRangeFromObject" + dateRangeFromObject);
                let dates = dateRangeFromObject.split( "," );
            setStartDate(new Date(dates[0]).getTime()/1000);
            setEndDate(new Date(dates[1]).getTime()/1000);
        }
        // fetchAllPrograms().then(response => setProgramList(response))
    }, [dateRange]);


    const DatePicker = () => {
        return (
            <DateRangePicker
                value={dateRange}
                onChange = {setDateRange}
                startLabel="Start date"
                endLabel="End date"
                monthsInView={2}
                presets={[
                    { label: "Last 14 days", value: [sevenDaysAgo, today] },
                ]}
                size="small"
                disabled={false}
                endError={false}
                startError={false}
            />
        )
    }

    function validateInput() {
        setError({
            aaaApplicationName: !aaaApplicationName,
            serviceName : !serviceName,
            packageName : !packageName,
            startDate: !startDate,
            endDate : !endDate,
            scalingFactor : !scalingFactor,
            region: !region,
            serviceType: !serviceType,
            accountId: !accountId
        });

        return aaaApplicationName && serviceName &&
            packageName && startDate && endDate && region
            && scalingFactor && accountId && serviceType;
    }

    function calculateTAT() {
        const params = {
            aaaApplicationName: aaaApplicationName,
            serviceName : serviceName,
            packageName : packageName,
            startDate: startDate,
            endDate : endDate,
            scalingFactor : parseFloat(scalingFactor),
            region: region,
            serviceType: serviceType,
            accountId: accountId
        };

        console.log("Input Parameters: " + params);

       if (validateInput()) {
           (async () => {
               const getTATCalculationsHeaders = await getHeadersForNFMS("GetTATCalculations");
               console.log("getTATCalculationsHeaders ", getTATCalculationsHeaders);
               setLoading(true);
               await axios
                   .post(getNFMSEndpoint(), params, getTATCalculationsHeaders)
                   .then((response) => {
                       if (response.status === 200) {
                           console.log("HIIIII");
                           setTatCalculationsList(response.data.aaaApplicationMetricDataList);
                           console.log("tatCalculationsList : " , tatCalculationsList);
                           // setAlert(successAlert);
                       }
                   }).catch((response) => {
                       console.log("BYEEEE : " , response);
                       // setAlert(getErrorAlertObjectFromResponse(response));
                   }).finally(() => {
                       setLoading(false);
                       setTatCalculationsList(dummy);
                   });
           })();
       }
    }

    return (
        <div className="App" style={{"text-align": "left"}}>
            {loading && <div style={{"zIndex": 100, "position": "absolute", "background-color": "rgba(255, 255, 255, 0.8)", "height": "100%", "width": "100%"}}>
                <Column width={"100%"} height={"100%"} alignmentVertical={"center"}>
                    <Row width={"100%"} height={"100%"} alignmentVertical={"center"} alignmentHorizontal={"center"}><Loader/></Row>
                </Column>
            </div>}
            <Row widths={["grid-12"]} alignmentVertical="top" spacingInset="none none medium large">
                <Row widths={["grid-12"]} alignmentVertical="top" >
                    <PageHeader {...PAGE_HEADERS.TAT_CALCULATOR} />
                </Row>
            </Row>

            <Row width="100%" widths={["grid-12"]} alignmentVertical="top" spacingInset="medium large medium large">
                <Column spacing="200" alignmentHorizontal="left">
                    <Box width={"30%"}>
                        <Row widths={["grid-6", "grid-6"]} alignmentVertical="top" spacingInset="none none medium none">
                            <Column spacing="200" alignmentHorizontal="left">
                                <Select label="Select Region" value={region} onChange={setRegion} width="100%" error={error.region && !region}>
                                    <SelectOption value="EU" label="EU" />
                                    <SelectOption value="NA" label="NA" />
                                    <SelectOption value="JP" label="JP" />
                                    <SelectOption value="IN" label="IN" />
                                </Select>
                            </Column>
                            <Column spacing="200" alignmentHorizontal="left">
                                <Select label="Select Service Type" value={serviceType} width="100%" error={error.serviceType && !serviceType}
                                        onChange={(i) => {setServiceType(i); i === "MAWS" ? setAccountId("igraph") : setAccountId(undefined)}}>
                                    <SelectOption value="MAWS" label="MAWS" />
                                    <SelectOption value="NAWS" label="NAWS" />
                                </Select>
                            </Column>
                        </Row>
                        <Row alignmentVertical="top" spacingInset="none none medium none">
                                <Input id="aaa-input" value={aaaApplicationName} width={"100%"} size={"xlarge"}
                                       onChange={setAaaApplicationName} type="text" label="AAA Application Name"
                                       error={error.aaaApplicationName && !aaaApplicationName}/>
                        </Row>
                        <Row alignmentVertical="top" spacingInset="none none medium none">
                            <Column width={"100%"} spacing="200" alignmentHorizontal="left">
                                <Input id="package-input" value={packageName} width={"100%"} size={"xlarge"}
                                       onChange={setPackageName} type="text" label="Enter Package Name"
                                       error={error.packageName && !packageName}/>
                            </Column>
                        </Row>
                        <Row alignmentVertical="top" spacingInset="none none medium none">
                            <Column width={"100%"} spacing="200" alignmentHorizontal="left">
                                <Input id="service-input" value={serviceName} width={"100%"} size={"xlarge"}
                                       onChange={setServiceName} type="text" label="Enter Service Name"
                                       error={error.serviceName && !serviceName}/>
                            </Column>
                        </Row>
                        <Row alignmentVertical="top" spacingInset="none none medium none">
                            <Column width={"100%"} spacing="200" alignmentHorizontal="left">
                                <Input
                                    disabled={serviceType === "MAWS"}
                                    id="account-input" value={accountId}
                                    error={error.serviceType && !serviceType}
                                    onChange={setAccountId} width={"100%"} size={"xlarge"}
                                    type="number" label={serviceType === "MAWS" ? "igraph" : "Enter Account Id"}/>
                            </Column>
                            <Column width={"100%"} spacing="200" alignmentHorizontal="left">
                                <Input id="scaling-input" value={scalingFactor} width={"100%"} size={"xlarge"}
                                       onChange={setScalingFactor} type="number" label="Enter Scaling factor"
                                       error={error.scalingFactor && !scalingFactor}/>
                            </Column>
                        </Row>
                        <Row alignmentVertical="top" spacingInset="none none medium none">
                            <Column width={"100%"} spacing="200" alignmentHorizontal="left">
                                <DatePicker/>
                            </Column>
                        </Row>

                        <Box>
                        <Row alignmentHorizontal="left" spacingInset="none none medium none">
                            <Column width={"100%"}>
                                <Button onClick={() => calculateTAT()} size="large" alignmentHorizontal="right" spacingInset="large large large none">
                                    <Icon tokens={tatCalculationsList.length ? checkCircleToken : cogToken} /> Calculate
                                </Button>
                            </Column>
                        </Row>
                        </Box>

                    </Box>
                </Column>
            </Row>
            <Row widths={["grid-12"]} spacingInset={"none large none large"}>
                <Column>
                    <GetLaunchDataTable/>
                </Column>
            </Row>

        </div>
    );
}

export default injectIntl(TatCalculator);




// WEBPACK FOOTER //
// ./src/components/tat-calculator/TatCalculator.js